import React from "react";

const DownloadCloud  = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M19.453 18.806v8.025l2.658-2.626 2.057 2.033L18 32.333l-6.168-6.095 2.057-2.033 2.657 2.626v-8.025h2.907ZM18 3c2.496 0 4.904.907 6.768 2.548a10.023 10.023 0 0 1 3.34 6.352 7.994 7.994 0 0 1 4.458 3.11 7.836 7.836 0 0 1-.903 10.098 8.035 8.035 0 0 1-4.94 2.288l-.001-2.842a8.57 8.57 0 0 0-2.494-6.045 8.77 8.77 0 0 0-6.065-2.584 8.778 8.778 0 0 0-6.158 2.358 8.578 8.578 0 0 0-2.721 5.947l-.006.324v2.842a8.034 8.034 0 0 1-4.94-2.287 7.835 7.835 0 0 1-.904-10.1A7.994 7.994 0 0 1 7.89 11.9a10.021 10.021 0 0 1 3.34-6.353A10.243 10.243 0 0 1 18 3Z"
            fill={fill}
        />
    </svg>
);

export default DownloadCloud;
